import { useDispatch } from "react-redux";
import API from "../api";
import { setToken, setUser, setSub, expVidPopup, setPasswordPopup, setRegionAccess, resetAuth } from "action/index.js";
import { useNavigate } from "react-router-dom";
import { clearOnboardingData } from "components/WebsiteTour/tourData";
import { useRef } from "react";

const useLogOut = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
   const isLoggingOut = useRef(false);

  const logout = async () => {
    if (isLoggingOut.current) return;
    
    isLoggingOut.current = true;
    
    try {
      await API({
        method: "POST",
        url: "logout",
      });
    } catch (error) {
      console.error("Logout error:", error);
    } finally {
      dispatch(resetAuth());
      clearOnboardingData();
      navigate("/auth/login?logout");
      isLoggingOut.current = false;
    }
  };

  const logoutDirectly = () => {
    dispatch(setToken(null));
    dispatch(setUser(null));
    dispatch(setSub(false));
    dispatch(expVidPopup(0));
    dispatch(setPasswordPopup(false));
     dispatch(setRegionAccess(true));
     clearOnboardingData();
    navigate("/auth/login");
  };

  return { logout, logoutDirectly };
};

export default useLogOut;
